import React from "react";

const Error404 = () => {
    return (
        <div className="text-center minHeight maxWidth">
            <p className="badge text-wrap bg-light fs-3 text-dark">Error404: Página no encontrada 😓</p>
        </div>
    );
};

export default Error404;
